// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IAllowContributionTaxConfigDto } from './IAllowContributionTaxConfigDto';
import {
    IAllowContributionTaxConfigDtoFromJSON,
    IAllowContributionTaxConfigDtoFromJSONTyped,
    IAllowContributionTaxConfigDtoToJSON,
    IAllowContributionTaxConfigDtoToJSONTyped,
} from './IAllowContributionTaxConfigDto';

/**
 * 
 * @export
 * @interface IAllowContributionConfigDto
 */
export interface IAllowContributionConfigDto {
    /**
     * 
     * @type {IAllowContributionTaxConfigDto}
     * @memberof IAllowContributionConfigDto
     */
    employee?: IAllowContributionTaxConfigDto;
    /**
     * 
     * @type {IAllowContributionTaxConfigDto}
     * @memberof IAllowContributionConfigDto
     */
    employer?: IAllowContributionTaxConfigDto;
    /**
     * 
     * @type {string}
     * @memberof IAllowContributionConfigDto
     */
    type?: IAllowContributionConfigDtoTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof IAllowContributionConfigDto
     */
    state?: IAllowContributionConfigDtoStateEnum;
}

/**
* @export
* @enum {string}
*/
export enum IAllowContributionConfigDtoTypeEnum {
    NONE = 'NONE',
    EMPLOYEE = 'EMPLOYEE',
    EMPLOYER = 'EMPLOYER',
    EMPLOYER_AND_EMPLOYEE = 'EMPLOYER_AND_EMPLOYEE'
}
/**
* @export
* @enum {string}
*/
export enum IAllowContributionConfigDtoStateEnum {
    MODIFIABLE = 'MODIFIABLE',
    LOCKED = 'LOCKED',
    HIDDEN = 'HIDDEN',
    REQUIRED_AT_PLAN = 'REQUIRED_AT_PLAN',
    REQUIRED_AT_ALL_LEVELS = 'REQUIRED_AT_ALL_LEVELS'
}


/**
 * Check if a given object implements the IAllowContributionConfigDto interface.
 */
export function instanceOfIAllowContributionConfigDto(value: object): value is IAllowContributionConfigDto {
    return true;
}

export function IAllowContributionConfigDtoFromJSON(json: any): IAllowContributionConfigDto {
    return IAllowContributionConfigDtoFromJSONTyped(json, false);
}

export function IAllowContributionConfigDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IAllowContributionConfigDto {
    if (json == null) {
        return json;
    }
    return {
        
        'employee': json['employee'] == null ? undefined : IAllowContributionTaxConfigDtoFromJSON(json['employee']),
        'employer': json['employer'] == null ? undefined : IAllowContributionTaxConfigDtoFromJSON(json['employer']),
        'type': json['type'] == null ? undefined : json['type'],
        'state': json['state'] == null ? undefined : json['state'],
    };
}

export function IAllowContributionConfigDtoToJSON(json: any): IAllowContributionConfigDto {
    return IAllowContributionConfigDtoToJSONTyped(json, false);
}

export function IAllowContributionConfigDtoToJSONTyped(value?: IAllowContributionConfigDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'employee': IAllowContributionTaxConfigDtoToJSON(value['employee']),
        'employer': IAllowContributionTaxConfigDtoToJSON(value['employer']),
        'type': value['type'],
        'state': value['state'],
    };
}

